import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton } from '@/components';
import { useSearchParams } from '@/hooks';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';

export default function StablecoinsActivityPage() {
  const { ilk } = useParams();

  const [daysAgo] = useSearchParams('days_ago', '1');

  const [data, error] = useApi({
    url: `/groups/stablecoins/ilks/${ilk}/events/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="6"
              />
            }>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name} Activity</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} />
        <EventsTable ilk={ilk} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
